
    import * as React from 'react';

    const Filter20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Filter_20_svg__Icons/Filter/20" stroke="none" strokeWidth={1} fillRule="evenodd"><g id="Filter_20_svg__Group" transform="translate(1.000000, 1.000000)" fillRule="nonzero"><rect id="Filter_20_svg__Rectangle" x={0} y={2} width={18} height={1} /><rect id="Filter_20_svg__Rectangle-Copy" x={0} y={8} width={18} height={1} /><rect id="Filter_20_svg__Rectangle-Copy-2" x={0} y={14} width={18} height={1} /><circle id="Filter_20_svg__Oval" cx={5.5} cy={2.5} r={2.5} /><circle id="Filter_20_svg__Oval-Copy" cx={12.5} cy={8.5} r={2.5} /><circle id="Filter_20_svg__Oval-Copy-2" cx={5.5} cy={14.5} r={2.5} /></g></g></svg>
        </div>
      );
    };

    Filter20.displayName = 'Filter20';

    export default Filter20;
  